import { Injectable } from '@angular/core';
import { ManualAddressDto } from '@shared/src/controllers/maps/ManualAddressDto';

@Injectable()
export class Route_eCMRPartnerDTO {
	public tenantId: number;
	public name: string;
	public nif: string;
	public address: ManualAddressDto;
	public contactName: string;
	public contactPhone: string;
	public reset: boolean;

	public static build(tenantId: number, name: string, nif: string, address: ManualAddressDto, contactName: string, contactPhone: string): Route_eCMRPartnerDTO {
		let result: Route_eCMRPartnerDTO = new Route_eCMRPartnerDTO();
		result.tenantId = tenantId;
		result.name = name;
		result.nif = nif;
		result.address = address;
		result.contactName = contactName;
		result.contactPhone = contactPhone;
		return result;
	}

	public static buildReset(): Route_eCMRPartnerDTO {
		let result: Route_eCMRPartnerDTO = new Route_eCMRPartnerDTO();
		result.reset = true;
		return result;
	}
}